import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewConfigComponent } from './view-config.component';



@NgModule({
  declarations: [
    ViewConfigComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ViewConfigComponent
  ]
})
export class ViewConfigModule { }
